export const USER_SCHOOL_LOADED = 'user.school.load';

export const userPageInit = payload => ({
  type: USER_SCHOOL_LOADED,
  payload
});
